import type RouterPage from '../../interfaces/RouterPage';
import type RouterPageContext from '../../interfaces/RouterPageContext';

export const emailRouterPages: RouterPage[] = [
  {
    hasDivider: false,
    href: '/emails/inbox',
    icon: 'InboxIcon',
    isDisabled: false,
    isHidden: false,
    key: 'email-inbox',
    label: 'email.inbox',
    notificationsCount: 0,
  },
  {
    hasDivider: false,
    href: '/emails/sent',
    icon: 'SendIcon',
    isDisabled: false,
    isHidden: false,
    key: 'email-sent',
    label: 'email.sent',
    notificationsCount: 0,
  },
  {
    hasDivider: false,
    href: '/emails/drafts',
    icon: 'FilePenLineIcon',
    isDisabled: false,
    isHidden: false,
    key: 'email-drafts',
    label: 'email.drafts',
    notificationsCount: 0,
  },
  {
    hasDivider: false,
    href: '/emails/favorites',
    icon: 'StarIcon',
    isDisabled: false,
    isHidden: false,
    key: 'email-favorites',
    label: 'email.favorites',
    notificationsCount: 0,
  },
  {
    hasDivider: false,
    href: '/emails/archive',
    icon: 'ArchiveIcon',
    isDisabled: false,
    isHidden: false,
    key: 'email-archive',
    label: 'email.archive',
    notificationsCount: 0,
  },
  {
    hasDivider: true,
    href: '/emails/trash',
    icon: 'TrashIcon',
    isDisabled: false,
    isHidden: false,
    key: 'email-trash',
    label: 'email.trash',
    notificationsCount: 0,
  },
];

/**
 * Filters the email router pages based on the context.
 * @param context RouterPageContext
 * @returns RouterPage[]
 */
export function filteredEmailRouterPages(context: RouterPageContext): RouterPage[] {
  return emailRouterPages.filter((page) => {
    if (page.condition) {
      return page.condition(context);
    }
    return true;
  });
}
